import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import SignUp from '../Page/account/SignUp';
import Layout from '../Page/Layout';
import EmailVerify from '../Page/account/EmailVerify';
import { LoginRoute } from './AuthRoute';
import ResetPwd from '../Page/account/ResetPwd';
import UserProfile from '../Page/account/Profile';
import AccountSetting from '../Page/account/Setting';
import MerchantProfile from '../Page/merchant/Profile';
import MerchantAccounts from '../Page/merchant/Accounts';
import MerchantHome from '../Page/merchant/Home';
import MemberSetting from '../Page/member/MemberSetting';
import Templates from '../Page/email/Templates';
import Template from '../Page/email/Template';
import Tasks from '../Page/email/Tasks';
import Event from '../Page/event/Event'
import Events from '../Page/event/Events'
import EventPreview from '../Page/event/EventPreview';

import Task from '../Page/email/Task';
import TaskResult from '../Page/email/TaskResult';
import Applicant from '../Page/event/Applicant';
import Coaches from '../Page/coach/Coaches';
import Dashboard from '../Page/dashboard/Home';
import CoachSignIn from '../Page/account/CoachSignIn';
import UserSetting from '../Page/setting/User';
import RoleSetting from '../Page/setting/Role';
import MenuSetting from '../Page/setting/Menu';
import BalanceSetting from '../Page/setting/Balance';
import AreaSetting from '../Page/setting/Area';
import Course from '../Page/lesson/Course';
import Courses from '../Page/lesson/Courses';
import Lesson from '../Page/lesson/Lesson';
import Classes from '../Page/classes/Classes';
import ClassHome from '../Page/classes/ClassHome';
import HolidaySetting from '../Page/setting/Holiday';
import FamilyManager from '../Page/member/Family';
import BalanceLog from '../Page/member/BalanceLog';
import TeachRecords from '../Page/coach/TeachRecords';
import Reports from '../Page/dashboard/Reports';
import CourseCategory from '../Page/lesson/CourseCategory';
import ClassNew from '../Page/website/ClassNew';
import ClassApplication from '../Page/website/ClassApplicants';
import ClassroomSetting from '../Page/setting/Classroom';
import TermSetting from '../Page/setting/Term';
import Page from '../Page/lesson/Page';
import PackageCourses from '../Page/lesson/PackageCourses';
import CoursePackages from '../Page/lesson/CoursePackages';
import MemberCourses from '../Page/member/MemberCourses';
import MonthReport from '../Page/report/MonthReport';

const App = () => {
  const theme = createTheme();
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Routes>
          <Route path="/" element={<LoginRoute path="signin" />} />
          <Route path="/account">
            <Route path="signup" element={<SignUp />} />
            <Route path="coach" element={<CoachSignIn />} />
            <Route path="signin" element={<LoginRoute path="signin" />} />
            <Route path="resetpwd" element={<ResetPwd />} />
          </Route>
          <Route path="/service" element={<Layout />}>
            <Route path="dashboard" element={<Dashboard />} ></Route>
            <Route path="reports" element={<Reports />}></Route>
            <Route path="user" >
              <Route path="profile" element={<UserProfile />} />
              <Route path="emailverify" element={<EmailVerify />} />
              <Route path="setting" element={<AccountSetting />} />
            </Route>
            <Route path="merchant">
              <Route path="home" element={<MerchantHome />} />
              <Route path="profile" element={<MerchantProfile />} />
              <Route path="accounts" element={<MerchantAccounts />} />
            </Route>
          </Route>
          <Route path="/member" element={<Layout />}>
            <Route path="family" element={<FamilyManager />} />     
            <Route path="course/:member_id/:category_id" element={<MemberCourses />} />                         
            <Route path="setting" element={<MemberSetting />} />     
            <Route path="balancelog/:userid/:memberid" element={<BalanceLog />}   />                 
          </Route>
          <Route path="/email" element={<Layout />}>
            <Route path="tasks" element={<Tasks />} />
            <Route path="task/:id" element={<Task />} />
            <Route path="templates" element={<Templates />} />
            <Route path="template/:id" element={<Template />} />        
            <Route path="taskresult/:id" element={<TaskResult />} />
          </Route>
         
          <Route path="/event" element={<Layout />}>
            <Route path="dashboard" element={<Events />} />
            <Route path="events" element={<Events />} />
            <Route path="event/:id" element={<Event />} />                          
            <Route path="applicant/:id" element={<Applicant />} />  
          </Route>           
          <Route path="/coach" element={<Layout />}>
            <Route path="coaches" element={<Coaches />} />  
            <Route path="lessonlog/:coachid" element={<TeachRecords />}   />   
          </Route>           
          <Route path="/setting" element={<Layout />}>
            <Route path="user/:roleid" element={<UserSetting />} />
            <Route path="role/:userid" element={<RoleSetting />} />
            <Route path="menu/:roleid" element={<MenuSetting />} />
            <Route path="balance" element={<BalanceSetting />} />
            <Route path="area" element={<AreaSetting />} />
            <Route path="term" element={<TermSetting />} />
            <Route path="classroom" element={<ClassroomSetting />} />
            <Route path="holiday" element={<HolidaySetting />}/>
          </Route>
          <Route path="/course" element={<Layout />}>
            <Route path="coursecategory" element={<CourseCategory />} />       
            <Route path="courses" element={<Courses />} />
            <Route path="coursepackage/:cid" element={<CoursePackages />} />
            <Route path="course/:courseid" element={<Course />} />
            <Route path="lesson/:lessonid" element={<Lesson />} />    
            <Route path="packagecourses" element={<PackageCourses />} />
          </Route>
          <Route path="/course/page/:id" element={<Page />} />
          <Route path="/website" element={<Layout />}>
                 
            <Route path="classnew/:ccid" element={<ClassNew />} />            
            <Route path="classapplicant/:ccid/:id" element={<ClassApplication />} />            
          </Route>
          <Route path="/class" element={<Layout />}>
            <Route path="classes" element={<Classes />} />            
            <Route path="class/:id" element={<ClassHome />} />               
          </Route>
          <Route path="/report" element={<Layout />}>
            <Route path="month" element={<MonthReport />} />                        
          </Route>
          <Route path="/event/preview/:id" element={<EventPreview />} />          
          <Route path="/activity/:id" element={<EventPreview />} />             
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
